import script from "./MakerCartGuide4Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide4Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide4Page.vue?vue&type=style&index=0&id=20809974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20809974"]])

export default __exports__